import React from 'react';
import {ModalBox, ImageBox, GalleryBox, ExitIcon, CustomImage} from '../Style/ImageModalView.style';
import {IProps} from '../Config/ImageModalView.types';


const ImageModalView = ({imageList, setOpen, open, currentImageIndex}: IProps) => (
    <>
        <ModalBox
            open={open}>
            <>
                <GalleryBox>
                    <ExitIcon fontSize={'medium'} onClick={() => setOpen(false)}/>
                    <ImageBox>
                        {imageList[currentImageIndex] && imageList[currentImageIndex].url && <CustomImage
                            src={currentImageIndex > -1 ? imageList[currentImageIndex].url : null}
                            alt='image'
                        />}
                    </ImageBox>
                </GalleryBox>
            </>
        </ModalBox>
    </>
);

export default ImageModalView;

